import { MInput, MDatePicker, MTextArea, MButton } from '@Components/Base';
import MTimePicker from '@Components/Filters/TimePicker/MTimePicker';
import { MobileDrawer } from '@Components/index';
import { Col, Flex, Form, Row } from 'antd';
import Text from 'antd/es/typography/Text';

import { FormikProps } from 'formik';
import { UnlockPricingFormValues } from '../UnlockPricingDialog';

import styles from './UnlockPricingDialog.module.css';

interface UnlockPricingMobileProps {
  isOpen: boolean;
  formik: FormikProps<UnlockPricingFormValues>;
  onCancel: () => void;
}

const UnlockPricingMobile: React.FC<UnlockPricingMobileProps> = ({
  formik,
  isOpen,
  onCancel,
}) => {
  const customButtons = (
    <div className={styles.buttonFooter}>
      <MButton
        onClick={() => {
          onCancel?.();
        }}
        type="tertiary"
      >
        Cancel
      </MButton>
      <MButton
        type="primary"
        disabled={!formik.isValid}
        onClick={() => {
          formik.submitForm();
        }}
      >
        Unlock
      </MButton>
    </div>
  );

  return (
    <MobileDrawer
      open={isOpen}
      title="Unlock Pricing"
      onClose={onCancel}
      footer={customButtons}
    >
      <form
        noValidate
        onSubmit={(e) => {
          e.nativeEvent.preventDefault();
          formik.submitForm();
        }}
        className={styles.unlockPricingMobile}
      >
        <Row>
          <Col span={24}>
            <Form.Item
              label="Expected Total Amount (AED)"
              className={styles.formItem}
            >
              <MInput name="expectedAmount" placeholder="Enter Amount" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Expiry Date" className={styles.formItem}>
              <MDatePicker
                name="expiryDate"
                placeholder="DD/MM/YYYY"
                onChange={(selectValue) => {
                  formik.setFieldValue('expiryDate', selectValue);
                }}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Expiry Time" className={styles.formItem}>
              <MTimePicker
                value={formik.values.expiryTime}
                showSecond={false}
                onChange={(selectValue) => {
                  formik.setFieldValue('expiryTime', selectValue);
                }}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Remarks" className={styles.formItem}>
              <MTextArea
                name="remarks"
                maxLength={20}
                title="Remarks"
                placeholder="Insert Remarks"
                onChange={(value) => {
                  formik.setFieldValue('remarks', value.target.value);
                }}
              />
              <Flex justify="end">
                {formik.values.remarks && (
                  <Text type="secondary">
                    {formik.values.remarks?.length}/20
                  </Text>
                )}
              </Flex>
              {formik.errors.remarks && (
                <Flex justify="end">
                  <Text type="danger">{formik.errors.remarks}</Text>
                </Flex>
              )}
            </Form.Item>
          </Col>
        </Row>
      </form>
    </MobileDrawer>
  );
};

export default UnlockPricingMobile;
